import { MarketingPageHeader } from '../Header/MarketingPageHeader';
import { Footer } from '../Landing/LandingFooter';
import { LandingHelp } from '../Landing/LandingHelp';
import { DeepLiquiditySection } from './DeepLiquiditySection';
import { LowCapTokensSection } from './LowCapTokensSection';
import { NewTradeModeSection } from './NewTradeModeSection';
import { SwapTokensBenefitsSection } from './SwapTokensBenefitsSection';
import { SwapTokensHero } from './SwapTokensHero';

export function SwapTokens() {
  return (
    <>
      <MarketingPageHeader />
      <SwapTokensHero />
      <main
        className="mx-[18px] tablet:mx-[44px] desktop:mx-auto desktop:p-4 pb-0 w-full"
        data-lock-theme="true"
      >
        <SwapTokensBenefitsSection />
        <DeepLiquiditySection />
        <LowCapTokensSection />
        <NewTradeModeSection />
        <LandingHelp />
      </main>
      <Footer />
    </>
  );
}
